<ng-container *ngIf="lessons">
  <div class="lesson-row mat-row" *ngFor="let lesson of lessons.sectionLessons; let index = index" [routerLink]="[
      '/courses',
      course.url,
      sectionSeqNo,
      'lessons',
      lesson.seqNo
    ]" [ngClass]="lessonClasses(lesson)">
    <ng-container *ngIf="showExtraIcons">
      <div class="lesson-icon" *ngIf="lesson.type == 'video'">
        <div class="svg-icon">
          <svg>
            <use xlink:href="#watchIcon"></use>
          </svg>
        </div>
      </div>

      <div class="lesson-icon" *ngIf="lesson.type == 'download'">
        <div class="svg-icon">
          <svg>
            <use xlink:href="#downloadIcon"></use>
          </svg>
        </div>
      </div>

      <div class="lesson-icon" *ngIf="lesson.type == 'text-only'">
        <div class="svg-icon">
          <svg>
            <use xlink:href="#plainTextIcon"></use>
          </svg>
        </div>
      </div>

      <div class="lesson-icon" *ngIf="lesson.type == 'quiz'">
        <div class="svg-icon">
          <svg>
            <use xlink:href="#quizIcon"></use>
          </svg>
        </div>
      </div>

      <div class="lesson-icon" *ngIf="lesson.type == 'assignment'">
        <div class="svg-icon">
          <svg>
            <use xlink:href="#assignmentIcon"></use>
          </svg>
        </div>
      </div>

      <div class="lesson-icon" *ngIf="lesson.type == 'audio'">
        <div class="svg-icon">
          <svg>
            <use xlink:href="#musicIcon"></use>
          </svg>
        </div>
      </div>
    </ng-container>

    <div class="lesson-description">
      {{ lesson.title }}
    </div>

    <div class="filler"></div>

    <div class="lesson-duration" *ngIf="lesson.type == 'video'">
      {{ lesson.videoDuration | duration }}
    </div>

    <div class="lesson-pro" *ngIf="!playlistMode && showExtraIcons">
      <div class="svg-icon" *ngIf="!lesson.free && !course.free" title="This is a Premium lesson">
        <svg>
          <use xlink:href="#lockIcon"></use>
        </svg>
      </div>
    </div>

    <div class="lesson-viewed" (click)="onCheckBoxToggled($event)">
      <mat-checkbox [checked]="isLessonWatched(lesson)" color="primary" (change)="onLessonViewedClicked($event, lesson)"
        #watched>
      </mat-checkbox>
    </div>
  </div>
</ng-container>